<template>
  <Fragment>
    <slot />
  </Fragment>
</template>

<script>
import { defineComponent, watch } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'
import { Fragment } from 'vue-fragment'

import { LincolnRLSGroupsService } from '@services'
import { useTryCatch, useCurrentUser, useUserCompany } from '@composables'

export default defineComponent({
  name: 'UserRLSWrapper',
  components: {
    Fragment
  },
  setup() {
    const { useMutations } = createVuexHelpers()

    const { SET_USER_COMPANY_RLS, UNSET_USER_COMPANY_RLS } = useMutations([
      'SET_USER_COMPANY_RLS',
      'UNSET_USER_COMPANY_RLS'
    ])

    const { userId, isSuperUser } = useCurrentUser()
    const { roleName: companyRoleName, roleValue: companyRoleValue } =
      useUserCompany()

    const getUserCompanyRLS = async () => {
      if (isSuperUser.value) return

      await useTryCatch(async () => {
        const { data } = await LincolnRLSGroupsService.listRLSGroupsByRole(
          companyRoleName.value,
          companyRoleValue.value
        )
        const { data: results } = data || {}

        SET_USER_COMPANY_RLS(results)
      })
    }

    watch(
      userId,
      async (newUserID) => {
        if (!!newUserID) {
          await getUserCompanyRLS()
        } else {
          UNSET_USER_COMPANY_RLS()
        }
      },
      { immediate: true }
    )

    return {}
  }
})
</script>
